import classNames from "classnames";
import React, { useEffect } from "react";
import useImportCsv from "../../../hooks/useImportCsv";
import useAsync from "../../../hooks/useAsync";
import Lottie from "react-lottie";
import Loading from "../../../animation/loading.json";
import {  Auth } from "aws-amplify";
import { getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";
import API from "../api/api.main"

function ImportTransferLoan() {
  const { onClickImportCsv, importFiles } = useImportCsv();

  useEffect(() => {
    if (importFiles) {
      onImportTransferLoan();
    }
  }, [importFiles]);

  const { loading, onAsync: onImportTransferLoan } = useAsync(async () => {
    for (const importFile of importFiles) {
      if (importFile?.request_id && importFile?.tx) {
        const request = await API.get(
          "MoneyHubAdmin",
          `/leasing/request/${importFile?.request_id}`,
          {}
        );

        if (!request?.leasing) {
          continue;
        }

        if (request?.leasing?.loan_status === "ยืนยัน") {
          const transferDate = getCurrentLocalDateTime()?.isoDateTime;
          await API.put(
            "MoneyHubAdmin",
            `/leasing/requestStatus/${importFile?.request_id}`,
            {
              body: {
                transferDate,
                new_loan_status: "สมบูรณ์",
                tx: importFile?.tx,
                reason: "",
              },
            }
          );
          await API.post("MoneyHubAdmin", "/leasing/loan", {
            body: {
              transferDate,
              request_id: importFile?.request_id,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        }
      }
    }
  });

  return (
    <div>
      {loading && (
        <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
          <div className="w-2/5 h-auto mx-auto  ">
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: Loading,
                isStopped: false,
                isPaused: false,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
            />
            <div className="text-center text-white text-xl">
              กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
            </div>
          </div>
        </div>
      )}
      <button
        className={classNames(
          "bg-blue-500 text-white px-2 py-1 rounded text-sm cursor-pointer ml-1 mb-1"
        )}
        onClick={onClickImportCsv}
      >
        Import Transfer Loan
      </button>
    </div>
  );
}

export default ImportTransferLoan;
